/**
 * Enum for expected failure reasons in host context, mapped to TeamsApp.ExpectedFailureReason.
 */
export enum HostContextExpectedFailureReason {
    Other = "other",
    PermissionError = "permissionError",
    NotFound = "notFound",
    Throttling = "throttling",
    Offline = "offline"
}
